import { Navigate } from "react-router-dom";

//--------Public-------
import Home2 from "../../pages/public/Home/Home2";
import LoginPage from "../../pages/LoginPage";
import Contact from "../../pages/public/Contact";

//--------Guest-------
import GuestRegister from "../../pages/public/guest/GuestRegisterEmail";
import GuestDetails from "../../pages/public/guest/GuestRegisterDetails";
import GuestLogin from "../../pages/public/guest/GuesttLogin";
import GuestResetPwdEmail from "../../pages/public/guest/GuestResetPwdEmail";
import GuestResetPwd from "../../pages/public/guest/GuestResetPwd";

//--------Staff-------
import StaffLogin from "../../pages/staff/auth/StaffLogin";
import StaffRegisterPassword from "../../pages/staff/auth/StaffRegisterPassword";
import StaffResetPwdEmail from "../../pages/staff/auth/StaffResetPwdEmail";
import StaffResetPwd from "../../pages/staff/auth/StaffResetPwd";

export const PublicRoutes = [
  {
    path: "/",
    element: <Home2 />,
  },
  {
    path: "/home",
    element: <Home2 />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },

  {
    path: "/contact",
    element: <Contact />,
  },

  {
    path: "/dev/register/:token",
    element: <StaffRegisterPassword />,
  },

  {
    path: "/dev/login",
    element: <StaffLogin />,
  },
  {
    path: "/dev/resetPassword",
    element: <StaffResetPwdEmail />,
  },
  {
    path: "/dev/resetPassword/:token",
    element: <StaffResetPwd />,
  },
  {
    path: "/guest/register",
    element: <GuestRegister />,
  },
  {
    path: "/guest/register/:token",
    element: <GuestDetails />,
  },
  {
    path: "/guest/login",
    element: <GuestLogin />,
  },
  {
    path: "/guest/resetPassword",
    element: <GuestResetPwdEmail />,
  },
  {
    path: "/guest/resetPassword/:token",
    element: <GuestResetPwd />,
  },
];
